import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

export const Row = withStyles(({ palette, spacing, breakpoints }: Theme) => ({
  root: {
    borderBottom: `1px solid ${palette.grey[200]}`,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: spacing(1, 0),
    [breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: spacing(2),
    },
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const Title = withStyles({})((props) => (
  <FsBodyBold component="h3" {...props} />
));

export const Category = withStyles(({ spacing }: Theme) => ({
  root: {
    marginBottom: spacing(1),
  },
}))((props) => <FsBodySmall component="p" {...props} />);

export const Date = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))((props) => <FsBodySmall component="span" {...props} />);

export const Price = withStyles({})((props) => (
  <FsBodyBold component="p" {...props} />
));

export const TextBox = withStyles(({ breakpoints, spacing }: Theme) => ({
  root: {
    flexGrow: 1,
    paddingRight: spacing(4),
    [breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
}))((props) => <Box {...props} />);

export const PriceBox = withStyles(({ spacing, breakpoints }: Theme) => ({
  root: {
    padding: spacing(2, 0),
    [breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
    },
  },
}))((props) => <Box {...props} />);

export const GraphsBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
    [breakpoints.up('sm')]: {
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    [breakpoints.up('md')]: {
      flexGrow: 0,
    },
  },
}))((props) => <Box {...props} />);
